import "../../../services/interface";
export default class DataProvider {
    constructor(options) {
        this._textAbove = options.textAbove;
        this._gdprText = options.gdprText;
        this._gdprLinkUrl = options.gdprLinkUrl;
        this._gdprLinkText = options.gdprLinkText;
        this._submitText = options.submitText;
        this._submitProcessing = options.submitProcessing;
        this._errEmailUsed = options.errEmailUsed;
        this._msgSuccess = options.msgSuccess;
    }
    get textAbove() {
        return this._textAbove;
    }
    get gdprText() {
        return this._gdprText;
    }
    get gdprLinkUrl() {
        return this._gdprLinkUrl;
    }
    get gdprLinkText() {
        return this._gdprLinkText;
    }
    get submitText() {
        return this._submitText;
    }
    get submitProcessing() {
        return this._submitProcessing;
    }
    get errEmailUsed() {
        return this._errEmailUsed;
    }
    get msgSuccess() {
        return this._msgSuccess;
    }
}
